import { GUEST_EMAIL_OTP, GUEST_EMAIL_OTP_ERROR, GUEST_EMAIL_OTP_HIDE_ERROR, GUEST_EMAIL_OTP_START_LOADER, GUEST_EMAIL_OTP_STOP_LOADER, } from "../interface/IGuestEmailVerifyOTP";
const initState = {
    data: {
        isClient: false,
        isGuest: false,
        message: "",
        uniqueID: "",
        emailOTPValidated: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const GuestEmailVerifyOTP = (state = initState, action) => {
    switch (action.type) {
        case GUEST_EMAIL_OTP:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case GUEST_EMAIL_OTP_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GUEST_EMAIL_OTP_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case GUEST_EMAIL_OTP_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GUEST_EMAIL_OTP_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default GuestEmailVerifyOTP;
